import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { contentHeaders, apiBaseUrl } from "../common/config/config";
import { ActionSheetController, Platform, LoadingController, ToastController } from "@ionic/angular";
let reportUrl = apiBaseUrl + 'reports';
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
import { Preferences } from '@capacitor/preferences';
import write_blob from "capacitor-blob-writer";
let filedogUrl = apiBaseUrl + "file_dog/";
import { UserService } from './user';
@Injectable({
  providedIn: 'root'
})
export class ReportService {
  public resp: any;
  public res: { status: { code: any; message: any }; data: any };
  public id: any;
  public app: any;
  public companyId: any;
  public branchId: any;
  public offline = [];
  public fileDogBusy = 0;
  public signedFiles = [];
  public appType: any;
  public formPreview = false;
  public txnId: any;
  public regNum: any;
  public survey = false;
  public surveyType = "initial";
  public perentIds = [];
  public changeProcess = false;
  public onResume = false;
  public processChanged = false;
  public firstPageSelected = '';
  public inProcessUploading = false;
  public inProcessUploadData = [];
  public location: any;
  public claimForm: any;
  public stencilsData = [];
  public process: any;
  public appConfig: any;
  public fileCount = 0;
  public hiddenImageCount = 0;
  public impactImageCount = 0;
  public screenImageCount = 0;
  public walkDirection = [];
  public audioCount = 0;
  public picNoCSP = 0;
  public audioObject = [];
  public signObject = [];
  public videoCount = 0;
  public impactImg = [];
  public propertyImg = [];
  public praReport = false;
  public localStencils = [];
  public imageTypes = [];
  public form: any;
  public workshops = [];
  public localFiles = [];
  public hiddenImages = [];
  public headers: any;
  public videoObject = [];
  public fileNames = [];
  public cameraImages = [];
  public imageTypeTaken = [];
  public fileUploadMonitor = [];
  public videoName: any;
  public reportImg = [];
  public putMonitor = [];
  constructor(
    public http: HttpClient,
    public platform: Platform,
    public users: UserService,
    public toaster: ToastController
  ) {
    this.headers = contentHeaders;
  }
  clearData() {
    this.resp = '';
    this.res = { status: { code: '', message: '' }, data: '' };
    this.id = '';
    this.app = '';
    this.txnId = '';
    this.regNum = '';
    this.branchId = '';
    this.formPreview = false;
    this.surveyType = "initial";
    this.changeProcess = false;
    this.onResume = false;
    this.processChanged = false;
    this.firstPageSelected = '';
    this.companyId = "";
    this.appType = "";
    this.perentIds = [];
    this.location = "";
    this.claimForm = "";
    this.stencilsData = [];
    this.process = "";
    this.appConfig = "";
    this.fileCount = 0;
    this.fileDogBusy = 0;
    this.signedFiles = [];
    this.hiddenImageCount = 0;
    this.impactImageCount = 0;
    this.screenImageCount = 0;
    this.walkDirection = [];
    this.survey = false;
    this.audioCount = 0;
    this.inProcessUploading = false;
    this.inProcessUploadData = [];
    this.picNoCSP = 0;
    this.audioObject = [];
    this.signObject = [];
    this.videoCount = 0;
    this.impactImg = [];
    this.localStencils = [];
    this.imageTypes = [];
    this.workshops = [];
    this.form = "";
    this.localFiles = [];
    this.hiddenImages = [];
    this.videoObject = [];
    this.fileNames = [];
    this.cameraImages = [];
    this.imageTypeTaken = [];
    this.fileUploadMonitor = [];
    this.videoName = "";
    this.reportImg = [];
    this.putMonitor = [];
  }
  uploadDrirect(fileName, sensorData, d) {
    try {
      d = new Date(d);
      let t = Math.floor(Math.random() * 2 + 5) * 1000;
      if (this.fileDogBusy > 3) {
        console.log(fileName, "filedog found busy");
        return true;
      }
      else {
        this.fileDogBusy++;
        let monitorIndex = this.fileUploadMonitor.findIndex((obj) => obj.filename == fileName);
        if (monitorIndex >= 0 && this.fileUploadMonitor[monitorIndex].status == "s") {
          this.fileUploadMonitor[monitorIndex].status = "t";
          this.fileUploadMonitor[monitorIndex].try = this.fileUploadMonitor[monitorIndex].try + 1;
          let signedIndex = this.signedFiles.findIndex((obj) => obj.filename == fileName);
          if (signedIndex < 0) {
            this.getSignedUploadRequest(fileName, "").subscribe((data) => {
              let reqUrl = data['signedRequest'];
              this.signedFiles.push({
                filename: fileName,
                fileId: data['fileId'],
                url: reqUrl,
                time: new Date().getTime(),
              });
              this.uploadToAws(fileName, sensorData, d, reqUrl, data['fileId']);
              return true;
            }, (error) => {
              console.log(error);
              this.fileDogBusy--;
              this.fileUploadMonitor[monitorIndex].status = "s";
              return true;
            });
          }
          else {
            let t = new Date().getTime();
            if (t - this.signedFiles[signedIndex].time > 500000) {
              this.signedFiles.splice(signedIndex, 1);
              this.fileUploadMonitor[monitorIndex].status = "s";
              this.fileDogBusy--;
              return true;
            } else {
              let requestUrl = this.signedFiles[signedIndex].url;
              let fileID = this.signedFiles[signedIndex].fileId;
              this.uploadToAws(fileName, sensorData, d, requestUrl, fileID);
              return true;
            }
          }
        }
      }
    } catch (e) {
      console.log(fileName, "error in direct upload", e);
      this.fileDogBusy--;
      setTimeout(() => {
        this.uploadDrirect(fileName, sensorData, d);
      }, 5000);
      return true;
    }
  }
  getSignedUploadRequest(name, type) {
    return this.http.get(`${filedogUrl}aws/sign?file-name=${name}&file-type=${type}`);
  }
  async uploadToAws(fileName, sensorData, d, url, fileId) {
    try {
      d = new Date(d);
      let t = Math.floor(Math.random() * 2 + 5) * 1000;
      let monitorIndex = this.fileUploadMonitor.findIndex((obj) => obj.filename == fileName);
      if (monitorIndex >= 0 && this.fileUploadMonitor[monitorIndex].status == "t") {
        if (this.fileUploadMonitor[monitorIndex].try < 15) {
          let fileContent = await Filesystem.readFile({ path: this.id + '/' + fileName, directory: Directory.Data }).catch(e => {
            console.log("filecontent => ", e);
          });
          if (fileContent && fileContent['data']) {
            let fileExt = fileName.includes(".jpg") ? 'image/jpg' : (fileName.includes(".png") ? 'image/png' : (fileName.includes(".m4a") ? 'audio/aac' : 'audio/webm'));
            let fileData = await this.base64toBlob(fileContent['data'], fileExt);
            this.uploadFile(url, fileData).subscribe((result) => {
              this.fileDogBusy--;
              if (this.inProcessUploading) {
                this.inProcessUploadData.push({
                  fileId: fileId,
                  filename: fileName,
                  sensorData: sensorData,
                  timestamp: d.getTime(),
                });
                this.updateReport({ "media.images.otherDoc": this.inProcessUploadData ,"otherDocuploaded": true }, "type");
              }
              else {
                let k = this.reportImg.findIndex((o) => o.filename == fileName);
                if (k < 0) {
                  this.reportImg.push({
                    fileId: fileId,
                    filename: fileName,
                    sensorData: sensorData,
                    timestamp: d.getTime(),
                  });
                } else {
                  this.reportImg[k].fileId = fileId;
                  this.reportImg[k].filename = fileName;
                  this.reportImg[k].sensorData = sensorData;
                  this.reportImg[k].timestamp = d.getTime();
                }
              }
              var signIn = this.signedFiles.findIndex((o) => o.filename == fileName);
              this.signedFiles.splice(signIn, 1);
              if (monitorIndex >= 0) this.fileUploadMonitor[monitorIndex].status = "d";
              console.log("reportimg", this.reportImg);
              return true;
            }, (error) => {
              this.fileDogBusy--;
              console.log(error);
              this.fileUploadMonitor[monitorIndex].status = "s";
              setTimeout(() => { this.uploadDrirect(fileName, sensorData, d); }, 3000);
              return true;
            });
          } else {
            this.fileDogBusy--;
            this.fileUploadMonitor[monitorIndex].status = "s";
            this.uploadDrirect(fileName, sensorData, d);
            return true;
          }
        } else {
          let signedIndex = this.signedFiles.findIndex((obj) => obj.filename == fileName);
          let k = this.reportImg.findIndex((o) => o.filename == fileName);
          let fNInd = this.fileNames.findIndex((o) => o.fileName == fileName);
          if (signedIndex < 0) {
            this.fileUploadMonitor.splice(monitorIndex, 1);
            if (k >= 0) this.reportImg.splice(k, 1);
            if (fNInd >= 0) this.fileNames.splice(fNInd, 1);
            if (fileName.includes('hidden')) {
              let hImInd = this.hiddenImages.findIndex((o) => o.fileName == fileName);
              if (hImInd >= 0) this.hiddenImages.splice(hImInd, 1);
            }
          } else {
            if (k < 0) {
              this.reportImg.push({
                fileId: this.signedFiles[signedIndex]['fileId'],
                filename: fileName,
                sensorData: sensorData,
                timestamp: d.getTime(),
              });
            } else {
              this.reportImg[k].fileId = this.signedFiles[signedIndex]['fileId'];
              this.reportImg[k].filename = fileName;
              this.reportImg[k].sensorData = sensorData;
              this.reportImg[k].timestamp = d.getTime();
            }
            this.signedFiles.splice(signedIndex, 1);
            this.fileUploadMonitor[monitorIndex].status = "d";
          }
        }
      }
    } catch (e) {
      console.log("errr", e);
      this.uploadDrirect(fileName, sensorData, d);
      return true;
    }
  }
  uploadFile(url, file) {
    return this.http.put(url, file);
  }
  dataURItoBlob(dataURI, contentType) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    // var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: contentType });

  }
  base64toBlob(dataURI, contentType) {
    let bytes: string = atob(dataURI);
    const byteNumbers = new Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
      byteNumbers[i] = bytes.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });

  }
  async uploadDataUrl(file, name, sensorData, d, reportId?) {
    try {
      d = new Date(d);
      let t = Math.floor(Math.random() * 2 + 5) * 1000;
      if (this.fileDogBusy > 3) {
        console.log(name, "filedog found busy");
        setTimeout(() => {
          this.uploadDataUrl(file, name, sensorData, d, reportId);
        }, 10000);
      }
      else {
        this.fileDogBusy++;
        this.getSignedUploadRequest(name, "").subscribe(async (data) => {
          console.log(data, "getSignedUploadRequest catch");
          let fileData = await this.dataURItoBlob(file, "image/jpeg");
          console.log(fileData, "dataURItoBlob");
          let requestUrl = data['signedRequest'];
          let fileID = data['fileId'];
          this.uploadFile(requestUrl, fileData).subscribe(async (res) => {
            console.log(res, "uploadFile");
            this.fileDogBusy--;
            if (this.inProcessUploading) {
               let oldRpt = await this.getReport(this.id);
                if(oldRpt && oldRpt['_id']){
                  if(oldRpt['media'] && oldRpt['media']['images'] && oldRpt['media']['images']['otherDoc'] && oldRpt['media']['images']['otherDoc'].length > 0){
                    oldRpt['media']['images']['otherDoc'].forEach(obj => {
                      this.inProcessUploadData.push(obj);
                    });
                  }
                }
              this.inProcessUploadData.push({
                fileId: fileID,
                filename: name,
                sensorData: sensorData,
                timestamp: d.getTime(),
              });
              this.updateReport({ "media.images.otherDoc": this.inProcessUploadData }, "type", reportId);
            }
            else {
              let k = this.reportImg.findIndex((o) => o.filename == name);
              if (k < 0) {
                this.reportImg.push({
                  fileId: data['fileId'],
                  filename: name,
                  sensorData: sensorData,
                  timestamp: d.getTime(),
                });
              } else {
                this.reportImg[k].fileId = data['fileId'];
                this.reportImg[k].filename = name;
                this.reportImg[k].sensorData = sensorData;
                this.reportImg[k].timestamp = d.getTime();
              }
            }
            console.log("reportimg", this.reportImg);
          }, (error) => {
            console.log(error);
            this.fileDogBusy--;
          })
        }, (error) => {
          console.log(error);
          this.fileDogBusy--;
        });
      }
      // if (this.fileDogBusy < 3) {
      //   this.uploadDrirect(user, index, location, fileName, sensorData, d, signal);
      // }
    } catch (e) {
      console.log(e, "filedog catch");
      setTimeout(() => {
        this.fileDogBusy--;
        this.uploadDataUrl(file, name, sensorData, d);
      }, 5000);
    }
  }
  async uploadDrirectBlob(file, name, sensorData, d) {
    try {
      d = new Date(d);
      let t = Math.floor(Math.random() * 2 + 5) * 1000;
      let monitorIndex = this.fileUploadMonitor.findIndex((obj) => obj.filename == name);
      if (monitorIndex >= 0 && this.fileUploadMonitor[monitorIndex].status == "s") {
        if (this.fileUploadMonitor[monitorIndex].try < 15) {
          this.fileUploadMonitor[monitorIndex].status = "t";
          this.fileUploadMonitor[monitorIndex].try = this.fileUploadMonitor[monitorIndex].try + 1;
          let signedIndex = this.signedFiles.findIndex((obj) => obj.filename == name);
          if (signedIndex < 0) {
            this.getSignedUploadRequest(name, "").subscribe(async (data) => {
              console.log(data, "getSignedUploadRequest catch");
              let reqUrl = data['signedRequest'];
              this.signedFiles.push({
                filename: name,
                fileId: data['fileId'],
                url: reqUrl,
                time: new Date().getTime(),
              });
              this.uploadFile(reqUrl, file).subscribe(async (res) => {
                console.log(res, "uploadFile");
                if (this.inProcessUploading) {
                  let oldRpt = await this.getReport(this.id);
                  if(oldRpt && oldRpt['_id']){
                    if(oldRpt['media'] && oldRpt['media']['images'] && oldRpt['media']['images']['otherDoc'] && oldRpt['media']['images']['otherDoc'].length > 0){
                      oldRpt['media']['images']['otherDoc'].forEach(obj => {
                        this.inProcessUploadData.push(obj);
                      });
                    }
                  }
                  this.inProcessUploadData.push({
                    fileId: data['fileId'],
                    filename: name,
                    sensorData: sensorData,
                    timestamp: d.getTime(),
                  });
                  this.updateReport({ "media.images.otherDoc": this.inProcessUploadData,"otherDocuploaded": true }, "type");
                }
                else {
                  let k = this.reportImg.findIndex((o) => o.filename == name);
                  if (k < 0) {
                    this.reportImg.push({
                      fileId: data['fileId'],
                      filename: name,
                      sensorData: sensorData,
                      timestamp: d.getTime(),
                    });
                  } else {
                    this.reportImg[k].fileId = data['fileId'];
                    this.reportImg[k].filename = name;
                    this.reportImg[k].sensorData = sensorData;
                    this.reportImg[k].timestamp = d.getTime();
                  }
                }
                var signIn = this.signedFiles.findIndex((o) => o.filename == name);
                this.signedFiles.splice(signIn, 1);
                if (monitorIndex >= 0) this.fileUploadMonitor[monitorIndex].status = "d";
                console.log("reportimg", this.reportImg);
                return true;
              }, (error) => {
                console.log(error);
                this.fileUploadMonitor[monitorIndex].status = "s";
                setTimeout(() => { this.uploadDrirectBlob(file, name, sensorData, d); }, 3000);
                return true;
              })
            }, (error) => {
              console.log(error);
              this.fileUploadMonitor[monitorIndex].status = "s";
              setTimeout(() => { this.uploadDrirectBlob(file, name, sensorData, d); }, 3000);
              return true;
            });
          }
          else {
            let t = new Date().getTime();
            if (t - this.signedFiles[signedIndex].time > 500000) {
              this.signedFiles.splice(signedIndex, 1);
              this.fileUploadMonitor[monitorIndex].status = "s";
              this.fileUploadMonitor[monitorIndex].try = this.fileUploadMonitor[monitorIndex].try + 1;
              setTimeout(() => { this.uploadDrirectBlob(file, name, sensorData, d); }, 3000);
            } else {
              let requestUrl = this.signedFiles[signedIndex].url;
              let fileID = this.signedFiles[signedIndex].fileId;
              this.uploadFile(requestUrl, file).subscribe(async (res) => {
                console.log(res, "uploadFile");
                this.fileDogBusy--;
                if (this.inProcessUploading) {
                   let oldRpt = await this.getReport(this.id);
                  if(oldRpt && oldRpt['_id']){
                    if(oldRpt['media'] && oldRpt['media']['images'] && oldRpt['media']['images']['otherDoc'] && oldRpt['media']['images']['otherDoc'].length > 0){
                      oldRpt['media']['images']['otherDoc'].forEach(obj => {
                        this.inProcessUploadData.push(obj);
                      });
                    }
                  }
                  this.inProcessUploadData.push({
                    fileId: fileID,
                    filename: name,
                    sensorData: sensorData,
                    timestamp: d.getTime(),
                  });
                  this.updateReport({ "media.images.otherDoc": this.inProcessUploadData,"otherDocuploaded": true }, "type");
                }
                else {
                  let k = this.reportImg.findIndex((o) => o.filename == name);
                  if (k < 0) {
                    this.reportImg.push({
                      fileId: fileID,
                      filename: name,
                      sensorData: sensorData,
                      timestamp: d.getTime(),
                    });
                  } else {
                    this.reportImg[k].fileId = fileID;
                    this.reportImg[k].filename = name;
                    this.reportImg[k].sensorData = sensorData;
                    this.reportImg[k].timestamp = d.getTime();
                  }
                }
                var signIn = this.signedFiles.findIndex((o) => o.filename == name);
                this.signedFiles.splice(signIn, 1);
                if (monitorIndex >= 0) this.fileUploadMonitor[monitorIndex].status = "d";
                console.log("reportimg", this.reportImg);
                return true;
              }, (error) => {
                console.log(error);
                this.fileDogBusy--;
                this.fileUploadMonitor[monitorIndex].status = "s";
                return true;
              })
            }
          }
        } else {
          let signedIndex = this.signedFiles.findIndex((obj) => obj.filename == name);
          let k = this.reportImg.findIndex((o) => o.filename == name);
          let fNInd = this.fileNames.findIndex((o) => o.fileName == name);
          if (signedIndex < 0) {
            this.fileUploadMonitor.splice(monitorIndex, 1);
            if (k >= 0) this.reportImg.splice(k, 1);
            if (fNInd >= 0) this.fileNames.splice(fNInd, 1);
            if (name.includes('hidden')) {
              let hImInd = this.hiddenImages.findIndex((o) => o.fileName == name);
              if (hImInd >= 0) this.hiddenImages.splice(hImInd, 1);
            }
          } else {
            if (k < 0) {
              this.reportImg.push({
                fileId: this.signedFiles[signedIndex]['fileId'],
                filename: name,
                sensorData: sensorData,
                timestamp: d.getTime(),
              });
            } else {
              this.reportImg[k].fileId = this.signedFiles[signedIndex]['fileId'];
              this.reportImg[k].filename = name;
              this.reportImg[k].sensorData = sensorData;
              this.reportImg[k].timestamp = d.getTime();
            }
            this.signedFiles.splice(signedIndex, 1);
            this.fileUploadMonitor[monitorIndex].status = "d";
          }
        }
      }
    } catch (e) {
      console.log(name, "error in direct bolb upload", e);
      setTimeout(() => { this.uploadDrirectBlob(file, name, sensorData, d); }, 3000);
      return true;
    }
  }
  saveFile(imageData, fileName, sensorData, d) {
    return new Promise((resolve, reject) => {
      try {
        // let newImgData = imageData.replace(/"/g, "");
        let bytes: string = atob(imageData);
        const byteNumbers = new Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
          byteNumbers[i] = bytes.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let temp = fileName.split(".");
        const fileBlob: Blob = new Blob([byteArray], { type: "image/" + temp[1] });
        // fileName = temp[0] + "_" + this.id + "." + temp[1];
        console.log(fileName);
        write_blob({
          path: this.id + '/' + fileName,
          blob: fileBlob,
          directory: Directory.Data,
          recursive: true
        }).then(res => {
          console.log("DONE WRITING", fileName);
          let fileIndex = this.localFiles.findIndex((obj) => obj.filename == fileName);
          if (fileIndex < 0 && !this.inProcessUploading)
            this.localFiles.push({ location: this.id, filename: fileName });
          let indMo = this.fileUploadMonitor.findIndex((o) => o.filename == fileName);
          console.log("i value to push fileUploadMonitor -->", indMo);
          if (indMo == -1) {
            this.fileUploadMonitor.push({
              filename: fileName,
              sensorData: sensorData,
              d: d,
              timestamp: new Date(),
              status: "s",
              try: 1
            });
          }
          this.uploadDrirect(fileName, sensorData, d);
          resolve("success");
        }, (error) => {
          console.log("Error while saving image ", error);
          let indMo = this.fileUploadMonitor.findIndex((o) => o.filename == fileName);
          console.log("i value to push fileUploadMonitor -->", indMo);
          if (indMo == -1) {
            this.fileUploadMonitor.push({
              filename: fileName,
              sensorData: sensorData,
              d: d,
              timestamp: new Date(),
              status: "s",
              try: 1,
              blob: fileBlob
            });
          }
          this.uploadDrirectBlob(fileName, fileBlob, sensorData, d);
          resolve("success");
        }).catch(err => {
          let indMo = this.fileUploadMonitor.findIndex((o) => o.filename == fileName);
          console.log("i value to push fileUploadMonitor -->", indMo);
          if (indMo == -1) {
            this.fileUploadMonitor.push({
              filename: fileName,
              sensorData: sensorData,
              d: d,
              timestamp: new Date(),
              status: "s",
              try: 1,
              blob: fileBlob
            });
          }
          console.log("Error while saving image ", err);
          this.uploadDrirectBlob(fileName, fileBlob, sensorData, d);
          resolve("success");
        });
      } catch (e) {
        console.log("Error while saving image ", e);
        reject("faliure");
      }
    });
  }
  async removeFile(dir, file) {
    await Filesystem.deleteFile({
      path: dir + '/' + file,
      directory: Directory.Data
    });
  }
  removeFiles(arr) {
    for (var i = 0; i < arr.length; i++) {
      console.log(arr[i].location, arr[i].filename);
      this.removeFile(arr[i].location, arr[i].filename);
      console.log(arr[i].location, arr[i].filename);
    }
  }
  saveAudioFile(imageData, fileName, sensorData, d) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(imageData);
        var audio = await fetch(`data:${imageData['mimeType']};base64,${imageData['recordDataBase64']}`);
        const fileBlob: Blob = await audio.blob();
        console.log(fileName);
        write_blob({
          path: this.id + '/' + fileName,
          blob: fileBlob,
          directory: Directory.Data,
          recursive: true
        }).then(res => {
          console.log("DONE WRITING", fileName);
          let fileIndex = this.localFiles.findIndex((obj) => obj.filename == fileName);
          if (fileIndex < 0 && !this.inProcessUploading)
            this.localFiles.push({ location: this.id, filename: fileName });
          let indMo = this.fileUploadMonitor.findIndex((o) => o.filename == fileName);
          console.log("i value to push fileUploadMonitor -->", indMo);
          if (indMo == -1) {
            this.fileUploadMonitor.push({
              filename: fileName,
              sensorData: sensorData,
              d: d,
              timestamp: new Date(),
              status: "s",
              try: 1
            });
          }
          this.uploadDrirect(fileName, sensorData, d);
          resolve("success");
        }, (error) => {
          console.log("Error while saving image ", error);
          let indMo = this.fileUploadMonitor.findIndex((o) => o.filename == fileName);
          console.log("i value to push fileUploadMonitor -->", indMo);
          if (indMo == -1) {
            this.fileUploadMonitor.push({
              filename: fileName,
              sensorData: sensorData,
              d: d,
              timestamp: new Date(),
              status: "s",
              try: 1,
              blob: fileBlob
            });
          }
          this.uploadDrirectBlob(fileName, fileBlob, sensorData, d);
          resolve("success");
        }).catch(err => {
          let indMo = this.fileUploadMonitor.findIndex((o) => o.filename == fileName);
          console.log("i value to push fileUploadMonitor -->", indMo);
          if (indMo == -1) {
            this.fileUploadMonitor.push({
              filename: fileName,
              sensorData: sensorData,
              d: d,
              timestamp: new Date(),
              status: "s",
              try: 1,
              blob: fileBlob
            });
          }
          console.log("Error while saving image ", err);
          this.uploadDrirectBlob(fileName, fileBlob, sensorData, d);
          resolve("success");
        });
      } catch (e) {
        console.log("Error while saving image ", e);
        reject("faliure");
      }
    });
  }
  saveVideoFile(fileName, sensorData, d) {
    return new Promise(async (resolve, reject) => {
      try {
        d = new Date(d);
        let t = Math.floor(Math.random() * 2 + 5) * 1000;
        let monitorIndex = this.fileUploadMonitor.findIndex((obj) => obj.filename == fileName);
        if (monitorIndex >= 0 && this.fileUploadMonitor[monitorIndex].status == "s") {
          if (this.fileUploadMonitor[monitorIndex].try < 15) {
            this.fileUploadMonitor[monitorIndex].status = "t";
            this.fileUploadMonitor[monitorIndex].try = this.fileUploadMonitor[monitorIndex].try + 1;
            let signedIndex = this.signedFiles.findIndex((obj) => obj.filename == fileName);
            if (signedIndex < 0) {
              this.getSignedUploadRequest(fileName, "").subscribe((data) => {
                let reqUrl = data['signedRequest'];
                this.signedFiles.push({
                  filename: fileName,
                  fileId: data['fileId'],
                  url: reqUrl,
                  time: new Date().getTime(),
                });
                this.uploadVideoToAws(fileName, sensorData, d, reqUrl, data['fileId']);
                return true;
              }, (error) => {
                console.log(error);
                this.fileUploadMonitor[monitorIndex].status = "s";
                setTimeout(() => { this.saveVideoFile(fileName, sensorData, d); }, 3000);
                return true;
              });
            }
            else {
              let t = new Date().getTime();
              if (t - this.signedFiles[signedIndex].time > 500000) {
                this.signedFiles.splice(signedIndex, 1);
                this.fileUploadMonitor[monitorIndex].status = "s";
                setTimeout(() => { this.saveVideoFile(fileName, sensorData, d); }, 3000);
                return true;
              } else {
                let requestUrl = this.signedFiles[signedIndex].url;
                let fileID = this.signedFiles[signedIndex].fileId;
                this.uploadVideoToAws(fileName, sensorData, d, requestUrl, fileID);
                return true;
              }
            }
          } else {
            let signedIndex = this.signedFiles.findIndex((obj) => obj.filename == fileName);
            let k = this.reportImg.findIndex((o) => o.filename == fileName);
            let fNInd = this.fileNames.findIndex((o) => o.fileName == fileName);
            let vInd = this.videoObject.findIndex((o) => o.fileName == fileName);
            if (signedIndex < 0) {
              this.fileUploadMonitor.splice(monitorIndex, 1);
              if (k >= 0) this.reportImg.splice(k, 1);
              if (fNInd >= 0) this.fileNames.splice(fNInd, 1);
              if (vInd >= 0) this.videoObject.splice(vInd, 1);
            } else {
              if (k < 0) {
                this.reportImg.push({
                  fileId: this.signedFiles[signedIndex]['fileId'],
                  filename: fileName,
                  sensorData: sensorData,
                  timestamp: d.getTime(),
                });
              } else {
                this.reportImg[k].fileId = this.signedFiles[signedIndex]['fileId'];
                this.reportImg[k].filename = fileName;
                this.reportImg[k].sensorData = sensorData;
                this.reportImg[k].timestamp = d.getTime();
              }
              this.signedFiles.splice(signedIndex, 1);
              this.fileUploadMonitor[monitorIndex].status = "d";
            }
          }
        }
      } catch (e) {
        setTimeout(() => { this.saveVideoFile(fileName, sensorData, d); }, 3000);
        return true;
      }
    });
  }
  async uploadVideoToAws(fileName, sensorData, d, url, fileId) {
    try {
      d = new Date(d);
      let t = Math.floor(Math.random() * 2 + 5) * 1000;
      let monitorIndex = this.fileUploadMonitor.findIndex((obj) => obj.filename == fileName);
      if (monitorIndex >= 0 && this.fileUploadMonitor[monitorIndex].status == "t") {
        let fileContent = await Filesystem.readFile({ path: this.id + '/' + fileName, directory: Directory.Data }).catch(e => {
          console.log("filecontent => ", e);
        });
        if (fileContent && fileContent['data']) {
          let fileExt = fileName.includes(".mkv") ? 'video/x-matroska' : 'video/mp4';
          let fileData = await this.base64toBlob(fileContent['data'], fileExt);
          this.uploadFile(url, fileData).subscribe((result) => {
            let k = this.reportImg.findIndex((o) => o.filename == fileName);
            if (k < 0) {
              this.reportImg.push({
                fileId: fileId,
                filename: fileName,
                sensorData: sensorData,
                timestamp: d.getTime(),
              });
            } else {
              this.reportImg[k].fileId = fileId;
              this.reportImg[k].filename = fileName;
              this.reportImg[k].sensorData = sensorData;
              this.reportImg[k].timestamp = d.getTime();
            }
            var signIn = this.signedFiles.findIndex((o) => o.filename == fileName);
            this.signedFiles.splice(signIn, 1);
            if (monitorIndex >= 0) this.fileUploadMonitor[monitorIndex].status = "d";
            console.log("reportimg", this.reportImg);
            return true;
          }, (error) => {
            console.log(error);
            this.fileUploadMonitor[monitorIndex].status = "s";
            setTimeout(() => { this.saveVideoFile(fileName, sensorData, d); }, 3000);
            return true;
          });
        } else {
          this.fileUploadMonitor[monitorIndex].status = "s";
          setTimeout(() => { this.saveVideoFile(fileName, sensorData, d); }, 3000);
          return true;
        }
      }

    } catch (e) {
      console.log("errr", e);
      setTimeout(() => { this.saveVideoFile(fileName, sensorData, d); }, 3000);
      return true;
    }
  }
  saveBlob(blob, fileName) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(fileName);
        write_blob({
          path: this.id + '/' + fileName,
          blob: blob,
          directory: Directory.Data,
          recursive: true
        }).then(res => {
          console.log("DONE WRITING", fileName);
          resolve("success");
        }, (error) => {
          console.log("Error while saving blob ", error);
          reject("faliure");
        }).catch(err => {
          console.log("catch Error while saving blob ", err);
          reject("faliure");
        });
      } catch (e) {
        console.log("Error while saving file ", e);
        reject("faliure");
      }
    });
  }
  resendLink(reportId) {
    return new Promise((resolve, reject) => {
      this.http.get(reportUrl + "/" + reportId + "/resendSms", { headers: this.headers }).subscribe((res) => {
        resolve(res['status']);
      }, (err) => {
        reject(err);
      });
    });
  }
  getReports(status, skip, user) {
    return new Promise((resolve, reject) => {
      this.http.get(reportUrl + "?status=" + status + "&appUserId=" + user + "&limit=15&skip=" + skip, { headers: this.headers }).subscribe((res) => {
        console.log(res['data'])
        for (var i = 0; i < res['data'].result.length; i++) {
          if (!(res['data'].result[i].companyData && res['data'].result[i].app)) {
            res['data'].result.splice(i, 1);
          }
        }
        setTimeout(() => {
          resolve(res['data']);
        }, 2000);
      }, (err) => {
        reject(err);
      });
    });
  }
   updateCustomer(data){
    return new Promise((resolve, reject) => {
      let method = this.http.post(apiBaseUrl + 'reports/clientUpdate', data);
      return method.subscribe(res => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }
  getReport(id) {
    return new Promise((resolve, reject) => {
      this.http.get(reportUrl + "/" + id, { headers: contentHeaders }).subscribe((resp) => {
        if (resp['status'].code == 200) {
         resolve(resp['data']['result'][0]);
        } else {
          reject(resp);
        }
      }, (err) => {
        reject(err);
      });
    });
  }
  updateFiles(type) {
    let t = this.putMonitor.findIndex((o) => o.type == type);
    if (t < 0) {
      let y = { type: type, status: false, ts: Date.now(), try: 1 }
      this.putMonitor.push(y);
      t = this.putMonitor.length - 1;
    } else { this.putMonitor[t].try = this.putMonitor[t].try + 1; }
    if (this.putMonitor[t] && this.putMonitor[t].status != true) {
      let data = [];
      let flag = true;
      let indexT = this.imageTypeTaken.findIndex((o) => o.type == type);
      console.log("imahetypetaken", type, indexT, this.imageTypeTaken);
      if (indexT >= 0) {
        for (var i = 0; i < this.fileNames.length; i++) {
          if (this.fileNames[i].type == type) {
            let obj = this.reportImg.find((o) => o.filename == this.fileNames[i].fileName);
            if (obj) data.push(obj);
            else {
              flag = false;
              break;
            }
          }
        }
      }
      else if (type == "walkDirection") {
        data = this.walkDirection;
      }
      else if (type == "workshops") {
        data = this.workshops;
      }
      else if (type == "recording") {
        for (var j = 0; j < this.audioObject.length; j++) {
          let obj = this.reportImg.find((o) => o.filename == this.audioObject[j].fileName);
          console.log("Inside recording- --- >", this.audioObject[j].fileName);
          if (obj) data.push(obj);
          else {
            flag = false;
            break;
          }
        }
      }
      else if (type == "hidden-recording") {
        data = this.reportImg.find((o) => o.filename.includes("hidden_audio"));
        if (!data) flag = false;
      }
      else if (type == "video") {
        for (var k = 0; k < this.videoObject.length; k++) {
          let obj = this.reportImg.find((o) => o.filename == this.videoObject[k].fileName);
          console.log("Inside video- --- >", this.videoObject, k);
          if (obj) data.push(obj);
          else {
            flag = false;
            break;
          }
        }
      }
      else if (type == "signatures") {
        for (var m = 0; m < this.signObject.length; m++) {
          let obj = this.reportImg.find((o) => o.filename == this.signObject[m].fileName);
          if (obj) data.push(obj);
          else {
            flag = false;
            break;
          }
        }
      }
      else if (type == "hidden") {
        for (var l = 0; l < this.hiddenImages.length; l++) {
          let obj = this.reportImg.find((o) => o.filename == this.hiddenImages[l].fileName);
          if (obj) data.push(obj);
          else {
            flag = false;
            break;
          }
        }
      }
      else {
        for (var n = 0; n < this.impactImg.length; n++) {
          let obj = this.reportImg.find((o) => o.filename == this.impactImg[n].fileName);
          if (obj) data.push(obj);
          else {
            flag = false;
            break;
          }
        }
      }
      if (flag) {
        if (!this.id || this.id === '') {
          if (this.localFiles && this.localFiles.length > 0) {
            this.id = this.localFiles[0].location;
          }
        }
        if (type == "video") this.updateReport({ "media.video.process": data }, type);
        else if (type == "walkDirection" || type == "workshops") this.updateReport({ [type]: data }, type);
        else if (type == "hidden") this.updateReport({ "hidden.images": data }, type);
        else if (type == "hidden-recording") this.updateReport({ "hidden.audio": data }, type);
        else if (type == "textStatement") this.updateReport({ "statements.appUser": data }, type);
        else if (type == "recording") this.updateReport({ "media.audio": data }, type);
        else if (type == "obd") this.updateReport({ "media.other": data }, type);
        else this.updateReport({ ["media.images." + [type]]: data }, type);
      }
      if (this.putMonitor[t].try >= 15) {
        this.putMonitor.splice(t, 1);
      }
      // else {
      //   setTimeout(() => {
      //     this.updateFiles(type);
      //   }, 2000);
      // } 
    }
  }
  async presentToast(text) {
    let toast = await this.toaster.create({
      message: text,
      duration: 3000,
      position: "top",
    });
    await toast.present();
  }
  updateReport(data, type, reportId?) {
    console.log("INSIDE updateReport", data, "=======>>>>>>>", type);
    this.headers = contentHeaders;
    let newData;
    let rId = reportId ? reportId : this.id;
    if (!rId) {
      console.error("Report ID is missing in updateReport");
      return Promise.reject("Report ID is missing");
    }
    if (this.survey) {
      if (this.surveyType == "final") {
        let keys = Object.keys(data);
        newData = { ["finalSurvey." + keys[0]]: data[keys[0]] };
      }
      else if (this.surveyType == "supplementry") {
        let keys = Object.keys(data);
        newData = { ["suplementarySurvey." + keys[0]]: data[keys[0]] };
      }
      else newData = data;
    } else newData = data;
    return new Promise((resolve, reject) => {
      this.http.put(reportUrl + "/" + rId, newData, { headers: this.headers }).subscribe(async (res) => {
        if (res['status'] && res['status'].code == 200) {
          if (this.inProcessUploading && type == "type") {
            this.presentToast("File uploaded Successfully");
            this.inProcessUploading = false;
            let rData = await Preferences.get({ key: "requests" });
            if (rData && rData != null && rData != undefined && rData.value && rData.value != null && rData.value != undefined) {
              let newRData = JSON.parse(rData.value);
              if (newRData && newRData.result) {
                for (let i = 0; i < newRData.result.length; i++) {
                  if (newRData.result[i]._id == this.id) {
                    if (!newRData.result[i]["media"]) {
                      newRData.result[i]["media"] = {};
                    }
                    if (!newRData.result[i]["media"]["images"]) {
                      newRData.result[i]["media"]["images"] = {};
                    }
                    newRData.result[i]["media"]["images"]["otherDoc"] = this.inProcessUploadData;
                    localStorage.setItem("requests", JSON.stringify(newRData));
                    this.inProcessUploadData = [];
                  }
                }
              }
            }
          }
          console.log(res, "hhhhhhhhhhh");
          let ind = this.putMonitor.findIndex((o) => o.type == type);
          if (ind >= 0) this.putMonitor[ind].status = true;
          console.log("updateeeeeeee -----", res['data'])
          resolve(res['data']);
        }
      }, (err) => {
        console.log("update report error", JSON.stringify(err));
        reject(err);
      });
    });

  }
  createReports(data, user) {
    let permission = false;
    let index = this.users.allApps.findIndex((obj) => obj._id == data.app);
    if (index >= 1 && this.users.allApps[index].function.permission && this.users.allApps[index].function.permission == true)
      permission = true;

    return new Promise((resolve, reject) => {
      this.http.post(reportUrl + "/?permission=" + permission, data, { headers: this.headers }).subscribe((res) => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }
  downloadZIP(files, id) {
    return new Promise((resolve, reject) => {
      this.http.post(apiBaseUrl + 'zip_it', { files: files }, { responseType: 'arraybuffer' }).subscribe(res => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    })
  }
  acptReq(id, user) {
    return new Promise((resolve, reject) => {
      this.http.put(reportUrl + '/' + id + '/acptReq', { user: user }, { headers: this.headers }).subscribe(res => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    })
  }
  rjctReq(id, data, company, branch, app, user) {
    let d = {
      user: user,
      company: company,
      branch: branch,
      app: app,
      mobile: data.mobile,
      reason: data.reason
    }
    return new Promise((resolve, reject) => {
      this.http.put(reportUrl + '/' + id + '/rjctReq', d, { headers: this.headers }).subscribe(res => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    })
  }
  async resetFileStat() {
    await this.asyncForEach(this.fileUploadMonitor, async (file, ind) => {
      if (file.status != 'd') {
        this.fileUploadMonitor[ind].status = 's';
      }
    });
    setTimeout(() => {
      this.startMonitor(-1, 0);
    }, 500);
  }
  async startMonitor(index, tr) {
    console.log("INSIDE START MONITOR", tr);
    tr++;
    let fileFlag = true;
    let RFlag = true;
    if (tr <= 25) {
      try {
        if (this.users.isNetwork) {
          let nInd = await this.fileUploadMonitor.findIndex(o => o.status != "d");
          if (nInd >= 0) {
            fileFlag = false;
            if (nInd != index) {
              index = nInd;
              if (this.fileUploadMonitor[nInd].blob) {
                console.log('monitor uploadDrirectBlob', this.fileUploadMonitor[nInd].filename);
                this.uploadDrirectBlob(this.fileUploadMonitor[nInd].blob, this.fileUploadMonitor[nInd].filename, this.fileUploadMonitor[nInd].sensorData, this.fileUploadMonitor[nInd].d);
              } else {
                if (this.fileUploadMonitor[nInd].filename.includes("video")) {
                  console.log('monitor saveVideoFile', this.fileUploadMonitor[nInd].filename);
                  this.saveVideoFile(this.fileUploadMonitor[nInd].filename, this.fileUploadMonitor[nInd].sensorData, this.fileUploadMonitor[nInd].d);
                }
                else {
                  console.log('monitor uploadDrirect', this.fileUploadMonitor[nInd].filename);
                  this.uploadDrirect(this.fileUploadMonitor[nInd].filename, this.fileUploadMonitor[nInd].sensorData, this.fileUploadMonitor[nInd].d);
                }
              }
            } else {
              console.log('monitor uploadDrirectBlob', this.fileUploadMonitor[nInd].filename);
            }
          }

          // await this.asyncForEach(this.fileUploadMonitor, async(file, ind)=>{
          //     console.log('monitor upload', file, ind);
          //     if(file.status != 'd'){
          //       this.fileUploadMonitor[ind].status = 's';
          //       fileFlag = false;
          //       if(file.blob){
          //         console.log('monitor uploadDrirectBlob', file.filename);
          //         this.uploadDrirectBlob(file.blob, file.filename, file.sensorData, file.d);
          //       } else {
          //         if(file.filename.includes("video")){
          //           console.log('monitor saveVideoFile', file.filename);
          //           this.saveVideoFile(file.filename, file.sensorData, file.d);
          //         }
          //         else {
          //           console.log('monitor uploadDrirect', file.filename);
          //           this.uploadDrirect(file.filename, file.sensorData, file.d);
          //         }
          //       }
          //     }
          // });
          if (fileFlag) {
            let pInd = await this.putMonitor.findIndex(o => o.status != true);
            if (pInd >= 0) {
              RFlag = false;
              console.log('monitor updateFiles', this.putMonitor[pInd].type);
              this.updateFiles(this.putMonitor[pInd].type);
            }
            // await this.asyncForEach(this.putMonitor, async(upType, ind)=>{
            //     console.log('monitor update', upType);
            //     if(upType.status != true){
            //       RFlag = false;
            //       console.log('monitor updateFiles', upType.type);
            //       this.updateFiles(upType.type);
            //     }
            // });
            if (RFlag) {
              console.log('Report updated');
            } else {
              setTimeout(() => { this.startMonitor(index, tr); }, 3000);
            }
          } else {
            setTimeout(() => { this.startMonitor(index, tr); }, 3000);
          }
        } else {
          tr = tr - 1;
          console.log('network Not available');
          alert("Internet not working");
          setTimeout(() => { this.startMonitor(index, tr); }, 2000);
        }
      } catch (error) {
        this.users.updateLogs({ data: this.users.name + " (" + this.users.mobile + ") startMonitor catch iisue : " + JSON.stringify(error) });
        console.log('catch monitor', error);
        setTimeout(() => { this.startMonitor(index, tr); }, 2000);
      }
    } else {
      this.resetFileStat();
    }
  };
  asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  };
}